import {AfterViewInit, Component, HostListener, OnDestroy, OnInit, ViewChild} from '@angular/core';
import {CommonModule} from '@angular/common';
import {FaIconLibrary, FontAwesomeModule} from '@fortawesome/angular-fontawesome';
// import Chart from 'chart.js/auto';
import {
    faAngleLeft,
    faAngleRight,
    faArrowDown,
    faArrowRightFromBracket,
    faArrowRightToBracket,
    faArrowUp,
    faCalendarDays,
    faCamera,
    faCircleXmark,
    faEye,
    faFileExcel,
    faGear,
    faRefresh,
    faSearch,
    faTasks,
    faToggleOff,
    faToggleOn,
    faVideoCamera
} from '@fortawesome/free-solid-svg-icons';
import {ApiService} from '../services/api.service';
import {AuthService} from '../services/auth.service';
import {ToastrService} from 'ngx-toastr';
import {FormsModule} from '@angular/forms';
import {BaseChartDirective} from 'ng2-charts';
import {Chart, ChartData, ChartDataset, ChartOptions, ChartType, registerables} from 'chart.js';
import {getFileNameFromResponse} from '../../common/utils';
import saveAs from 'file-saver';
import {ImageViewerComponent} from '../shared/image-viewer/image-viewer.component';
import {GenericSearchComponent} from '../shared/search-suggestion/search-suggestion.component';
import {Router} from '@angular/router';
import {RoleService} from '../services/role.service';
import {SalesManagerDashboardComponent} from './sales-manager-dashboard.component';
import {displayCameraEsn} from '../shared/camera-display';
import {VehicleNumberCopyDirective} from '../shared/vehicle-number-copy/vehicle-number-copy.directive';
import {finalize, Subject, takeUntil} from 'rxjs';
import {DEFAULT_TABLE_PAGE_SIZE_OPTIONS} from '../shared/constants/pagination.constants';


Chart.register(...registerables);

type SuperuserDashboardCard = {
  label: string;
  value: number | string | null | undefined;
  route?: string;
  queryParams?: Record<string, any>;
};

type SuperuserTableRow = {
  subscription_id?: number;
  customer: string;
  amount_due?: string;
  due_date?: string;
  subscription_status?: string;
  days_overdue?: number;
  expiry_date?: string;
  renewal_date?: string;
  contract_value?: string;
  status?: string;
  contact_person?: string;
};

type DashboardColumnKey = 'parking_time' | 'camera' | 'images';

@Component({
    selector: 'app-dashboard',
    templateUrl: './dashboard.component.html',
    styleUrls: ['./dashboard.component.css'],
    imports: [CommonModule, FormsModule, FontAwesomeModule, BaseChartDirective, ImageViewerComponent, GenericSearchComponent, SalesManagerDashboardComponent, VehicleNumberCopyDirective]
})
export class DashboardComponent implements OnInit, AfterViewInit, OnDestroy  {
    readonly pageSizeOptions = DEFAULT_TABLE_PAGE_SIZE_OPTIONS;
  isSuperUser = false;
  isSalesManager = false;
  superuserLoading = false;
  superuserError = false;
  superuserDashboard: any = {
    customers: { total: 0, active: 0 },
    sales: {
      total_leads: 0,
      new_leads: 0,
      followups_due_today: 0,
      demos_scheduled: 0,
      won_leads: 0,
    },
    revenue: {
      total_sales_value: '0.00',
      received_amount: '0.00',
      pending_amount: '0.00',
      expiring_soon: 0,
    },
    operations: {
      total_cameras: 0,
      active_cameras: 0,
      vehicle_logs_today: 0,
      webhook_failures: 0,
    },
    pending_payments: [],
    renewals_due_soon: [],
    revenue_trend: [],
    payment_trend: [],
    lead_funnel: {
      new: 0,
      contacted: 0,
      demo_scheduled: 0,
      demo_completed: 0,
      negotiation: 0,
      won: 0,
    },
    lead_sources: [],
    top_customers: [],
    attention: {
      overdue_payments: 0,
      inactive_customers: 0,
      no_followup_leads: 0,
      webhook_failures: 0,
    },
    subscription_health: {
      active: 0,
      expiring_soon: 0,
      expired: 0,
      cancelled: 0,
    },
    sales_installation_partners: {
      total: 0,
      active: 0,
      leads: 0,
      organizations: 0,
      installations: 0,
      estimated_revenue: '0.00',
      pending_follow_ups: 0,
      top_performing: [],
    },
  };
  selectedImages: { url: string; direction: 'Entry' | 'Exit' }[] = [];
  showModal: boolean = false;
  searchText: string | null = null;
  recordsPerPage: number = 10;
  currentPage: number = 1;
  totalRecords: number = 0;
  nextPage: number | null = null;
  previousPage: number | null = null;
  todayDate: Date = new Date();
  isLoading: boolean = true;
  staleUnmatchedCount = 0;
  staleUnmatchedThresholdHours = 24;
  zoneOccupancy = {
    capacity: 0,
    occupied: 0,
    available: 0,
    occupancy_percent: 0,
  };
  availableCameras: string[] = [];
  selectedCameraFilter = '';
  isVideoMode = false;
  showTooltip = false;
  
  hoveredColumn = '';
  sortColumn: string = '';
  sortDirection: 'asc' | 'desc' = 'asc';

  // Image slideshow properties
  cameraFeedImages: { url: string; direction: 'Entry' | 'Exit' }[] = [];
  currentImageIndex: number = 0;
  autoPlayInterval: any;

  // Placeholder image settings for missing/broken URLs
  slideshowPlaceholderUrl = 'no-image.png';
  videoPlaceholderUrl = 'logo/no-video.png';
  imageLoadFailed = false;
  failedImageLabel = 'Image not available';

  selectedRange = '7days';
  barChartType: ChartType = 'bar';


  camera_esn = [];
  todaysActivity:any;
  mostRecentActivity:any;
  cardData!:any;
  chartvalue!: any;

// status filter
  vehicleStatus: string = ''
  showColumnSettings = false;
  showDateFilter = false;
  activityDateRange = 'today';
  activityDateRanges = [
    { label: 'Today', value: 'today' },
    { label: 'Yesterday', value: 'yesterday' },
    { label: 'Last 7 Days', value: '7days' },
    { label: 'Last Month', value: 'month' },
  ];
  dashboardColumns: Array<{ key: DashboardColumnKey; label: string; visible: boolean }> = [
    { key: 'parking_time', label: 'Parking Time', visible: true },
    { key: 'camera', label: 'Camera', visible: true },
    { key: 'images', label: 'Vehicle Images', visible: true },
  ];

  rawData: any = {
    status_filter: '',
    sort_column: '',
    time_range: 'today',
  };



  constructor(library: FaIconLibrary,
    private apiService: ApiService,
    private authService: AuthService,
    private toastr: ToastrService,
    private router: Router,
    private roleService: RoleService
  ){
    library.addIcons(faTasks,
                    faSearch,
                    faEye,
                    faFileExcel,
                    faGear,
                    faCircleXmark,
                    faAngleRight,
                    faAngleLeft,
                    faRefresh,
                    faVideoCamera,
                    faCamera,
                    faCalendarDays,
                    faToggleOn,
                    faToggleOff,
                    faArrowUp,
                    faArrowDown,
                    faArrowRightToBracket,
                    faArrowRightFromBracket
                     )
  }


  chartOptions: ChartOptions = {
    responsive: true,
    onHover: (event) => {
          (event.native?.target as HTMLElement).style.cursor = 'pointer';
        },
    scales: {
      x: { 
         stacked: true,
      },
      y: {
        beginAtZero: true,
        stacked: true,
      },
    },
    plugins: {
      legend: {
        position: 'bottom',
      },
    },
    animation: {
      duration: 800,
      easing: 'easeOutQuart'
    }
  };

  chartData: ChartData<'bar'> = {
    labels: [],
    datasets: [],
  };
  superuserChartOptions: ChartOptions = {
    responsive: true,
    maintainAspectRatio: false,
    plugins: {
      legend: {
        position: 'bottom',
      },
    },
  };
  superuserLineChartType: ChartType = 'line';
  superuserBarChartType: ChartType = 'bar';
  superuserDoughnutChartType: ChartType = 'doughnut';

  timeRanges = [
    { label: 'Today', value: 'today' },
    { label: 'Yesterday', value: 'yesterday' },
    { label: 'Last 7 Days', value: '7days' },
    { label: '1 Month', value: 'month' },
  ];
 
  hasUserInteracted = false;
  private chartReady = false;
  private pendingChartData: any | null = null;
  private destroy$ = new Subject<void>();



  ngOnInit() {
    this.destroy$ = new Subject<void>();
    this.isSuperUser = this.authService.isSuperUser();
    this.isSalesManager = this.roleService.isSalesManager(this.authService.getCurrentUserInfo()?.role);
    this.camera_esn = this.authService.getCurrentUserInfo()['camera_esn'] || [];
    this.availableCameras = Array.isArray(this.camera_esn) ? [...this.camera_esn] : [];

    if (this.isSuperUser) {
      this.loadSuperuserDashboard();
      return;
    }

    if (this.isSalesManager) {
      this.isLoading = false;
      return;
    }

    this.stats(this.currentPage, this.recordsPerPage);
    this.loadChartData(this.selectedRange);
    this.loadDashboardColumnSettings();

    // this.updateChart(this.selectedRange);
    window.addEventListener('click', () => {
    this.hasUserInteracted = true;
  }, { once: true });
    for (const key in this.finalCounts) {
      this.animateCount(key as keyof typeof this.finalCounts);
    }
  }

  displayCameraEsn(record: any): string {
    return displayCameraEsn(record);
  }

  getCameraDisplayParts(record: any): Array<{ label: string; value: string }> {
    if (!record) {
      return [];
    }
    const entry = record.entry_camera_esn;
    const exit = record.exit_camera_esn;
    if (entry && exit && entry !== exit) {
      return [{ label: '', value: `${entry} & ${exit}` }];
    }
    const value = entry || exit || record.camera_esn || record.camera_esn_display;
    if (!value) {
      return [];
    }
    return [{ label: '', value }];
  }

  isDashboardColumnVisible(key: DashboardColumnKey): boolean {
    return this.dashboardColumns.find(column => column.key === key)?.visible !== false;
  }

  toggleColumnSettings() {
    this.showColumnSettings = !this.showColumnSettings;
  }

  toggleDateFilter() {
    this.showDateFilter = !this.showDateFilter;
  }

  selectActivityDateRange(range: string) {
    this.activityDateRange = range;
    this.showDateFilter = false;
    this.currentPage = 1;
    this.stats(this.currentPage, this.recordsPerPage);
  }

  get selectedActivityDateLabel(): string {
    return this.activityDateRanges.find(range => range.value === this.activityDateRange)?.label || 'Today';
  }

  @HostListener('document:click', ['$event'])
  closeMenusOnOutsideClick(event: Event) {
    const target = event.target as HTMLElement;
    if (!target.closest('.column-settings')) {
      this.showColumnSettings = false;
    }
    if (!target.closest('.date-filter')) {
      this.showDateFilter = false;
    }
  }

  @HostListener('document:keydown.escape')
  closeMenusOnEscape() {
    this.showColumnSettings = false;
    this.showDateFilter = false;
  }

  updateDashboardColumn(column: { key: DashboardColumnKey; label: string; visible: boolean }, event: Event) {
    const input = event.target as HTMLInputElement;
    column.visible = input.checked;
    this.saveDashboardColumnSettings();
  }

  private dashboardColumnSettingsKey(): string {
    const userId = this.authService.getCurrentUserInfo()?.id || 'anonymous';
    return `dashboardTodayActivityColumns:${userId}`;
  }

  private loadDashboardColumnSettings() {
    try {
      const raw = localStorage.getItem(this.dashboardColumnSettingsKey());
      if (!raw) {
        return;
      }
      const stored = JSON.parse(raw);
      this.dashboardColumns = this.dashboardColumns.map(column => ({
        ...column,
        visible: stored[column.key] !== false,
      }));
    } catch {
      this.saveDashboardColumnSettings();
    }
  }

  private saveDashboardColumnSettings() {
    const payload = this.dashboardColumns.reduce((acc: Record<string, boolean>, column) => {
      acc[column.key] = column.visible;
      return acc;
    }, {});
    localStorage.setItem(this.dashboardColumnSettingsKey(), JSON.stringify(payload));
  }

   ngAfterViewInit() {
    if (this.isSuperUser) {
      return;
    }
    this.chartReady = true;
    if (this.pendingChartData) {
      this.applyChartData(this.pendingChartData);
      this.pendingChartData = null;
    }

  }
  
  finalCounts = {
    entry: 12800,
    exit: 12000,
    matched: 11500,
    unmatched: 1300
  };

  displayedCounts = {
    entry: 0,
    exit: 0,
    matched: 0,
    unmatched: 0
  };

  private tickAudio = new Audio('audio/tick.wav');
  duration = 1000;


  animateCount(key: keyof typeof this.finalCounts) {
    const start = 0;
    const end = this.finalCounts[key];
    const duration = this.duration;
    const startTime = performance.now();

    const easeOutCubic = (t: number) => 1 - Math.pow(1 - t, 3);
    let lastDisplayed = 0;

    const animate = (currentTime: number) => {
      const elapsed = currentTime - startTime;
      const progress = Math.min(elapsed / duration, 1);
      const easedProgress = easeOutCubic(progress);

      const currentVal = Math.floor(start + (end - start) * easedProgress);

      if (currentVal !== lastDisplayed) {
        this.displayedCounts[key] = currentVal;
        this.playTick();  // play sound only when count updates
        lastDisplayed = currentVal;
      }

      if (progress < 1) {
        requestAnimationFrame(animate);
      } else {
        this.displayedCounts[key] = end;
      }
    };

    requestAnimationFrame(animate);
  }

  playTick() {
    if (!this.hasUserInteracted) return;
    const tick = this.tickAudio.cloneNode() as HTMLAudioElement;
    tick.volume = 0.1; // Adjust volume
    tick.play().catch((err) => {
      console.error('Play error:', err)
    });
  }

  @ViewChild(BaseChartDirective) chart!: BaseChartDirective;

  barChartData: ChartDataset<'bar'>[] = [];

  updateChart(range: string){
    this.selectedRange = range;
    this.loadChartData(range);
  }

  private loadChartData(range: string) {
    let data: any = {
      'camera_esn': this.activeCameraEsn,
      'time_range': range
    }
    this.apiService.vehicleMovement(data).pipe(takeUntil(this.destroy$)).subscribe({
        next: (res:any) => {
          const chData = res['chart_data'];
          if (!this.chartReady) {
            this.pendingChartData = chData;
            return;
          }
          this.applyChartData(chData);
        },
        error: (err) =>{

        if (err['error']['non_field_errors']) {
                      err['error']['non_field_errors'].forEach((element:any) => {
                        this.toastr.error(element);
                      });
        }
         else if (err['status'] !== 403 && err.status !== 0) {
          this.toastr.error("Something went wrong!.", 'Error');
      }
      // else {
      //     this.toastr.error("Error while getting vehicle movements!.");
      //   }
    }
    })
  }

  loadSuperuserDashboard() {
    this.superuserLoading = true;
    this.superuserError = false;
    this.apiService.getSuperuserDashboard().pipe(takeUntil(this.destroy$)).subscribe({
      next: (response: any) => {
        this.superuserDashboard = {
          ...this.superuserDashboard,
          ...response,
          customers: response?.customers || this.superuserDashboard.customers,
          sales: response?.sales || this.superuserDashboard.sales,
          revenue: response?.revenue || this.superuserDashboard.revenue,
          operations: response?.operations || this.superuserDashboard.operations,
          pending_payments: response?.pending_payments || [],
          renewals_due_soon: response?.renewals_due_soon || [],
        };
        this.superuserLoading = false;
      },
      error: (err) => {
        this.superuserLoading = false;
        this.superuserError = true;
        if (err?.status !== 0) {
          this.toastr.error('Unable to load business dashboard.', 'Error');
        }
      }
    });
  }

  get summaryCards(): SuperuserDashboardCard[] {
      const organizationsListing = this.roleService.organizationsListingQueryParams();
      const activeOrganizationsListing = this.roleService.organizationsListingQueryParams(true);
    return [
        {
            label: 'Total Customers',
            value: this.superuserDashboard.customers?.total,
            route: 'organization',
            queryParams: organizationsListing
        },
        {
            label: 'Active Customers',
            value: this.superuserDashboard.customers?.active,
            route: 'organization',
            queryParams: activeOrganizationsListing
        },
      { label: 'Total Leads', value: this.superuserDashboard.sales?.total_leads, route: 'lead-management/leads' },
      { label: 'Pending Amount', value: this.superuserDashboard.revenue?.pending_amount, route: 'subscriptions' },
    ];
  }

  get salesCards(): SuperuserDashboardCard[] {
    return [
      { label: 'New Leads', value: this.superuserDashboard.sales?.new_leads, route: 'lead-management/leads', queryParams: { status: 'NEW' } },
      { label: 'Follow-ups Due Today', value: this.superuserDashboard.sales?.followups_due_today, route: 'lead-management/follow-ups', queryParams: { date: this.todayAsQueryParam() } },
      { label: 'Demo Scheduled', value: this.superuserDashboard.sales?.demos_scheduled, route: 'lead-management/demo-schedule', queryParams: { status: 'SCHEDULED' } },
      { label: 'Won Leads', value: this.superuserDashboard.sales?.won_leads, route: 'lead-management/leads', queryParams: { status: 'WON' } },
    ];
  }

  get salesInstallationPartnerCards(): SuperuserDashboardCard[] {
      const organizationsListing = this.roleService.organizationsListingQueryParams();
    return [
      { label: 'Total Sales & Installation Partners', value: this.superuserDashboard.sales_installation_partners?.total, route: 'admin/sales-installation-partners' },
      { label: 'Active Sales & Installation Partners', value: this.superuserDashboard.sales_installation_partners?.active, route: 'admin/sales-installation-partners' },
      { label: 'Leads via Sales & Installation Partners', value: this.superuserDashboard.sales_installation_partners?.leads, route: 'lead-management/leads', queryParams: { source: 'SALES_INSTALLATION_PARTNER' } },
        {
            label: 'Organizations via Sales & Installation Partners',
            value: this.superuserDashboard.sales_installation_partners?.organizations,
            route: 'organization',
            queryParams: organizationsListing
        },
        {
            label: 'Installations handled by Sales & Installation Partners',
            value: this.superuserDashboard.sales_installation_partners?.installations,
            route: 'organization',
            queryParams: organizationsListing
        },
      { label: 'Estimated Revenue via Sales & Installation Partners', value: this.superuserDashboard.sales_installation_partners?.estimated_revenue, route: 'subscriptions' },
      { label: 'Pending Partner Follow-ups', value: this.superuserDashboard.sales_installation_partners?.pending_follow_ups, route: 'admin/sales-installation-partners' },
    ];
  }

  get revenueCards(): SuperuserDashboardCard[] {
    return [
      { label: 'Total Sales Value', value: this.superuserDashboard.revenue?.total_sales_value, route: 'subscriptions' },
      { label: 'Received Amount', value: this.superuserDashboard.revenue?.received_amount, route: 'subscriptions' },
      { label: 'Pending Amount', value: this.superuserDashboard.revenue?.pending_amount, route: 'subscriptions' },
      { label: 'Expiring Soon', value: this.superuserDashboard.revenue?.expiring_soon, route: 'subscriptions' },
    ];
  }

  get operationsCards(): SuperuserDashboardCard[] {
    return [
      { label: 'Total Cameras', value: this.superuserDashboard.operations?.total_cameras, route: 'view-cameras' },
      { label: 'Active Cameras', value: this.superuserDashboard.operations?.active_cameras, route: 'view-cameras' },
      { label: 'Vehicle Logs Today', value: this.superuserDashboard.operations?.vehicle_logs_today },
      { label: 'Webhook Failures', value: this.superuserDashboard.operations?.webhook_failures },
    ];
  }

  get attentionCards(): SuperuserDashboardCard[] {
      const organizationsListing = this.roleService.organizationsListingQueryParams();
    return [
      { label: 'Overdue Payments', value: this.superuserDashboard.attention?.overdue_payments, route: 'subscriptions' },
        {
            label: 'Inactive Customers',
            value: this.superuserDashboard.attention?.inactive_customers,
            route: 'organization',
            queryParams: organizationsListing
        },
      { label: 'No Follow-up Leads', value: this.superuserDashboard.attention?.no_followup_leads, route: 'lead-management/leads', queryParams: { followup: 'missing' } },
      { label: 'Webhook Failures', value: this.superuserDashboard.attention?.webhook_failures, route: 'logs' },
    ];
  }

  get revenueTrendChartData(): ChartData<'line'> {
    const rows = this.superuserDashboard.revenue_trend || [];
    return {
      labels: rows.map((item: any) => item.month),
      datasets: [
        {
          label: 'Revenue',
          data: rows.map((item: any) => Number(item.amount || 0)),
          borderColor: '#2563eb',
          backgroundColor: 'rgba(37, 99, 235, 0.12)',
          fill: true,
          tension: 0.3,
        }
      ]
    };
  }

  get paymentTrendChartData(): ChartData<'bar'> {
    const rows = this.superuserDashboard.payment_trend || [];
    return {
      labels: rows.map((item: any) => item.month),
      datasets: [
        {
          label: 'Paid',
          data: rows.map((item: any) => Number(item.paid || 0)),
          backgroundColor: '#16a34a',
          borderRadius: 6,
        },
        {
          label: 'Pending',
          data: rows.map((item: any) => Number(item.pending || 0)),
          backgroundColor: '#f59e0b',
          borderRadius: 6,
        }
      ]
    };
  }

  get leadFunnelChartData(): ChartData<'bar'> {
    const funnel = this.superuserDashboard.lead_funnel || {};
    return {
      labels: ['New', 'Contacted', 'Demo Scheduled', 'Demo Completed', 'Negotiation', 'Won'],
      datasets: [
        {
          label: 'Leads',
          data: [
            funnel.new || 0,
            funnel.contacted || 0,
            funnel.demo_scheduled || 0,
            funnel.demo_completed || 0,
            funnel.negotiation || 0,
            funnel.won || 0,
          ],
          backgroundColor: ['#0ea5e9', '#22c55e', '#6366f1', '#8b5cf6', '#f59e0b', '#10b981'],
          borderRadius: 6,
        }
      ]
    };
  }

  get leadFunnelChartOptions(): ChartOptions {
    return {
      ...this.superuserChartOptions,
      indexAxis: 'y',
    };
  }

  get leadSourceChartData(): ChartData<'bar'> {
    const rows = this.superuserDashboard.lead_sources || [];
    return {
      labels: rows.map((item: any) => item.source),
      datasets: [
        {
          label: 'Total Leads',
          data: rows.map((item: any) => Number(item.count || 0)),
          backgroundColor: '#60a5fa',
          borderRadius: 6,
        },
        {
          label: 'Won Leads',
          data: rows.map((item: any) => Number(item.won || 0)),
          backgroundColor: '#34d399',
          borderRadius: 6,
        }
      ]
    };
  }

  get subscriptionHealthChartData(): ChartData<'doughnut'> {
    const health = this.superuserDashboard.subscription_health || {};
    return {
      labels: ['Active', 'Expiring Soon', 'Expired', 'Cancelled'],
      datasets: [
        {
          data: [
            Number(health.active || 0),
            Number(health.expiring_soon || 0),
            Number(health.expired || 0),
            Number(health.cancelled || 0),
          ],
          backgroundColor: ['#22c55e', '#f59e0b', '#ef4444', '#6b7280'],
          hoverBackgroundColor: ['#16a34a', '#d97706', '#dc2626', '#4b5563'],
          borderWidth: 0,
        }
      ]
    };
  }

  get hasRevenueTrendData(): boolean {
    return (this.superuserDashboard.revenue_trend || []).some((item: any) => Number(item.amount || 0) > 0);
  }

  get hasPaymentTrendData(): boolean {
    return (this.superuserDashboard.payment_trend || []).some(
      (item: any) => Number(item.paid || 0) > 0 || Number(item.pending || 0) > 0
    );
  }

  get hasLeadSourceData(): boolean {
    return (this.superuserDashboard.lead_sources || []).length > 0;
  }

  get hasSubscriptionHealthData(): boolean {
    const health = this.superuserDashboard.subscription_health || {};
    return ['active', 'expiring_soon', 'expired', 'cancelled'].some((key) => Number(health[key] || 0) > 0);
  }

  openSuperuserCard(card: SuperuserDashboardCard) {
    if (!card.route) {
      return;
    }
    this.router.navigate([card.route], { queryParams: card.queryParams || {} });
  }

  openSubscriptionDetail(row: SuperuserTableRow) {
    if (!row.subscription_id) {
      return;
    }
    this.router.navigate([`subscriptions/${row.subscription_id}`]);
  }

  formatAmount(value: string | number | null | undefined): string {
    const numericValue = Number(value ?? 0);
    if (Number.isNaN(numericValue)) {
      return '₹0.00';
    }
    return new Intl.NumberFormat('en-IN', {
      style: 'currency',
      currency: 'INR',
      minimumFractionDigits: 2,
      maximumFractionDigits: 2,
    }).format(numericValue);
  }

  formatStatus(value: string | null | undefined): string {
    return (value || '').replace(/_/g, ' ') || '-';
  }

  isCardClickable(card: SuperuserDashboardCard): boolean {
    return !!card.route;
  }

  private todayAsQueryParam(): string {
    const today = new Date();
    const year = today.getFullYear();
    const month = `${today.getMonth() + 1}`.padStart(2, '0');
    const day = `${today.getDate()}`.padStart(2, '0');
    return `${year}-${month}-${day}`;
  }

  private applyChartData(chData: any) {
    const canvas = this.chart?.chart?.canvas;
    const ctx = canvas?.getContext('2d');

    if (!ctx || !canvas) return;
    const gradientColors = this.getGradientColors(ctx, canvas);

    this.barChartData = [
      {
        label: 'Entry',
        data: chData.data?.entry,
        backgroundColor: gradientColors[0],
        stack: 'stack1',
        borderRadius: 3
      },
      {
        label: 'Exit',
        data: chData.data?.exit,
        backgroundColor: gradientColors[1],
        stack: 'stack1',
        borderRadius: 3
      },
      {
        label: 'Matched',
        data: chData.data?.matched,
        backgroundColor: gradientColors[2],
        stack: 'stack2',
        borderRadius: 3
      },
      {
        label: 'Unmatched',
        data: chData.data?.unmatched,
        backgroundColor: gradientColors[3],
        stack: 'stack2',
        borderRadius: 3
      },
      {
          label: 'Hotlisted',
        data: chData.data?.hot_listed,
        backgroundColor: gradientColors[4],
        stack: 'stack3',
        borderRadius: 3
      },
      {
        label: 'Blacklist',
        data: chData.data?.black_listed,
        backgroundColor: gradientColors[5],
        stack: 'stack3',
        borderRadius: 3
      }
    ]
    this.updateStackedYAxis(chData.labels)

    this.chartData = {
      labels: chData.labels,
      datasets: this.barChartData
    }
    this.chart.update();
  }

  getGradientColors(ctx: CanvasRenderingContext2D, canvas: any): string[] {
    const width = canvas.width;
    const height = canvas.height;

    
    const gradients: any = [];

    const colorPairs = [
      // ['#3b82f6', '#2563eb'],
      // ['#ff6f91', '#af1380'],
      // ['#10b981', '#047857'],
      // ['#f97316', '#ea580c'],


      ["#86E8CE", "#B5F4E2"],
      ["#FFDD94", "#FFE7B7"],
      ["#D6E8A5", "#E7F7C1"],
      ["#FA897B", "#FFB4A5"],
      ["#CCA8DB", "#E3C1F5"],
      ["#230f73ff", "#5A2D82"]
    ];

    for (const [start, end] of colorPairs) {
      const gradient = ctx.createLinearGradient(0, 0, width, height);
      gradient.addColorStop(0, start);
      gradient.addColorStop(1, end);
      gradients.push(gradient);
    }

    return gradients;
  }


updateStackedYAxis(barChartLabels: []) {
  const labelCount = barChartLabels.length;
  const stackGroups: { [stack: string]: number[] } = {};

  // Group data by stack
  this.barChartData.forEach(dataset => {
    const stack = dataset.stack || 'default';
    if (!stackGroups[stack]) {
      stackGroups[stack] = Array(labelCount).fill(0);
    }

    dataset.data.forEach((value: any, index: number) => {
      stackGroups[stack][index] += typeof value === 'number' ? value : 0;
    });
  });

  // Get max of stacked totals
  const allStackSums = Object.values(stackGroups).flat();
  const maxStacked = Math.max(...allStackSums);
  const buffer = Math.ceil(maxStacked * 0.1); // 20% buffer

  if (!this.chartOptions.scales) this.chartOptions.scales = {};
  this.chartOptions.scales['y'] = {
    beginAtZero: true,
    stacked: true,
    suggestedMax: maxStacked + buffer
  };

  this.chart?.chart?.update();
}

  
  viewImage(entryImageUrl: string, exitImageUrl?: string): void {
    this.selectedImages = [];
    
    if (entryImageUrl) {
      this.selectedImages.push({ url: entryImageUrl, direction: 'Entry' });
    }
    
    if (exitImageUrl) {
      this.selectedImages.push({ url: exitImageUrl, direction: 'Exit' });
    }
    
    this.showModal = true;
  }

  closeModal = () => {
    this.showModal = false;
  }

  onImageLoad() {
    this.imageLoadFailed = false;
    this.failedImageLabel = 'Image not available';
  }

  onImageError(event: Event, type: 'slideshow' | 'video' = 'slideshow') {
    const img = event.target as HTMLImageElement;
    
    if (!img) {
      return;
    }

    // If already attempted fallback, show alt text
    if (img.src.includes(this.slideshowPlaceholderUrl) || img.src.includes(this.videoPlaceholderUrl)) {
      this.imageLoadFailed = true;
      this.failedImageLabel = img.alt || 'Unable to load';
      img.style.display = 'none';
      return;
    }

    // Set the correct fallback based on context.
    if (type === 'video') {
      img.src = this.videoPlaceholderUrl;
      img.classList.add('placeholder-image');
      this.failedImageLabel = img.alt || 'No video available';
    } else {
      img.src = this.slideshowPlaceholderUrl;
      img.classList.add('placeholder-image');
      this.failedImageLabel = img.alt || 'No image available';
    }
  }

  get totalPages(): number {
      let totalPage = Math.ceil(this.totalRecords / this.recordsPerPage);
      if (totalPage === 0){
        totalPage = 1;
      }
      return totalPage;
    }

  // deleteRecord(index: number) {}
  next() {
    if (this.nextPage){
      this.currentPage++;
      // this.isLoading=true;
      this.stats(this.currentPage, this.recordsPerPage)
    }
  }

  previous() {
    if (this.previousPage){
      this.currentPage--;
      this.stats(this.currentPage, this.recordsPerPage)
      }
  }

  selectPageSize(){
    if(this.recordsPerPage){
      // debugger;
      this.currentPage = 1;
      this.stats(this.currentPage, this.recordsPerPage)
    }
  }



toggleMedia() {
  this.isVideoMode = !this.isVideoMode;
}

sortData(column: string) {
  
  if (this.sortColumn === column) {
    this.sortDirection = this.sortDirection === 'asc' ? 'desc' : 'asc';
  } else {
    this.sortColumn = column;
    this.sortDirection = 'asc';
      }
  this.stats(this.currentPage, this.recordsPerPage)       

  }

    hasCrossDayEntryExit(vehicle: { entry_time?: string | null; exit_time?: string | null }): boolean {
        const entryDate = this.getSessionLocalDateKey(vehicle?.entry_time);
        const exitDate = this.getSessionLocalDateKey(vehicle?.exit_time);
        return !!entryDate && !!exitDate && entryDate !== exitDate;
    }

    private getSessionLocalDateKey(value: string | null | undefined): string | null {
        if (!value || value === '-') {
            return null;
        }
        const parsed = new Date(value);
        if (Number.isNaN(parsed.getTime())) {
            return null;
        }
        return `${parsed.getFullYear()}-${parsed.getMonth()}-${parsed.getDate()}`;
    }

  // Format a single parking time string to exclude zero hours/minutes and add spacing between units
  formatParkingTimeString(timeStr: string): string {
    if (!timeStr || timeStr === '-') {
      return '-';
    }

    // Extract hours, minutes, and seconds using regex
    const hoursMatch = timeStr.match(/(\d+)h/);
    const minutesMatch = timeStr.match(/(\d+)m/);
    const secondsMatch = timeStr.match(/(\d+)s/);

    const hours = hoursMatch ? parseInt(hoursMatch[1]) : 0;
    const minutes = minutesMatch ? parseInt(minutesMatch[1]) : 0;
    const seconds = secondsMatch ? parseInt(secondsMatch[1]) : 0;

    // Build parts array, only non-zero values, then join with spaces
    const parts: string[] = [];
    if (hours > 0) parts.push(`${hours}h`);
    if (minutes > 0) parts.push(`${minutes}m`);
    if (seconds > 0) parts.push(`${seconds}s`);

    return parts.join(' ') || '-';
  }

  // Format all parking times in the activity array
  formatParkingTimesInActivity(activity: any[]): any[] {
    return activity.map(item => ({
      ...item,
      parking_time_str: this.formatParkingTimeString(item.parking_time_str)
    }));
  }

  stats(page: number, pageSize: number){
    this.isLoading = true;
    this.rawData = {
       'camera_esn': this.activeCameraEsn,
       'status_filter': '',
       'time_range': this.activityDateRange,
       'search_text': this.searchText || ''
    }
    if (this.vehicleStatus){
      this.rawData['status_filter'] = this.vehicleStatus
    }
    if (this.sortColumn){
      if (this.sortDirection === "desc"){
            this.rawData['sort_column'] = `-${this.sortColumn}`
          }
      else{
         this.rawData['sort_column'] = `${this.sortColumn}`
      }
    }
        
    this.apiService.dashboard(page, pageSize, this.rawData).pipe(
      takeUntil(this.destroy$),
      finalize(() => {
        this.isLoading = false;
      })
    ).subscribe({
      next:(res: any) => {
          const staleSummary = res['results']?.['stale_unmatched'] || res['stale_unmatched'];
          this.staleUnmatchedCount = Number(staleSummary?.count || 0);
          this.staleUnmatchedThresholdHours = Number(staleSummary?.threshold_hours || 24);
          const occupancy = res['results']?.['zone_occupancy'] || res['zone_occupancy'];
          if (occupancy) {
            this.zoneOccupancy = {
              capacity: Number(occupancy.capacity || 0),
              occupied: Number(occupancy.occupied || 0),
              available: Number(occupancy.available || 0),
              occupancy_percent: Number(occupancy.occupancy_percent || 0),
            };
          }
          this.cardData = {
            'inCount': res['results']['in_count'],
            'outCount': res['results']['out_count'],
            'matchedCount': res['results']['matched_count'],
            'unmatchedCount': res['results']['unmatched_count'],
            'inPercentChange': res['results']['in_percent_change'],
            'outPercentChange': res['results']['out_percent_change'],
            'matchedPercentChange': res['results']['matched_percent_change'],
            'unmatchedPercentChange': res['results']['unmatched_percent_change'],
          };
          this.todaysActivity = this.formatParkingTimesInActivity(res['results']['todays_activity']);
          this.mostRecentActivity = res['results']['most_recent_activity'];
          this.initializeCameraFeedImages();

          this.totalRecords = res['count'];
          this.nextPage = res['next'];
          this.previousPage = res['previous'];

    },
    error: (err) =>{
      if (err['error']['non_field_errors']) {
                    err['error']['non_field_errors'].forEach((element:any) => {
                      this.toastr.error(element);
                    });
      }
       else if (err['status'] !== 403 && err.status !== 0) { 
        this.toastr.error("Something went wrong!", 'Error');
      }
    }
             
    })
  }

  initializeCameraFeedImages() {
    this.cameraFeedImages = [];
    this.currentImageIndex = 0;

    if (this.mostRecentActivity) {
      if (this.mostRecentActivity.entry_vehicle_image_url) {
        this.cameraFeedImages.push({
          url: this.mostRecentActivity.entry_vehicle_image_url,
          direction: 'Entry'
        });
      }

      if (this.mostRecentActivity.exit_vehicle_image_url) {
        this.cameraFeedImages.push({
          url: this.mostRecentActivity.exit_vehicle_image_url,
          direction: 'Exit'
        });
      }
    }

    // If no images, add a placeholder
    if (this.cameraFeedImages.length === 0) {
      this.cameraFeedImages.push({
        url: this.slideshowPlaceholderUrl,
        direction: 'Entry'
      });
    }
  }

  nextImage() {
    if (this.cameraFeedImages.length > 1) {
      this.currentImageIndex = (this.currentImageIndex + 1) % this.cameraFeedImages.length;
    }
  }

  previousImage() {
    if (this.cameraFeedImages.length > 1) {
      this.currentImageIndex = (this.currentImageIndex - 1 + this.cameraFeedImages.length) % this.cameraFeedImages.length;
    }
  }

  getCurrentImage() {
    return this.cameraFeedImages[this.currentImageIndex];
  }

  get activeCameraEsn(): string[] {
    if (this.selectedCameraFilter) {
      return [this.selectedCameraFilter];
    }
    return this.availableCameras.length ? this.availableCameras : (this.camera_esn || []);
  }

  get dashboardSearchExtraBody(): Record<string, unknown> {
    return {
      camera_esn: this.activeCameraEsn,
      status_filter: this.rawData.status_filter || '',
      sort_column: this.rawData.sort_column || '',
      time_range: this.activityDateRange,
    };
  }

  selectCameraFilter() {
    this.currentPage = 1;
    this.stats(this.currentPage, this.recordsPerPage);
    this.loadChartData(this.selectedRange);
  }

  goToStaleVehiclesReview() {
    void this.router.navigate(['/analytics'], { fragment: 'stale-unmatched' });
  }

  navigateVehicleEntry(status: string) {
      const {fromDate, toDate} = this.getDashboardDateRangeBounds(this.activityDateRange);
      const formData: any = {
          from_date: this.formatDateParam(fromDate),
          to_date: this.formatDateParam(toDate),
          camera_esn: this.activeCameraEsn,
          from_dashboard: true,
          dashboard_filter: status,
          dashboard_time_range: this.activityDateRange,
      };
    this.router.navigate(['/reports'], {
      state: formData
    });
  }

    private formatDateParam(date: Date): string {
        const year = date.getFullYear();
        const month = `${date.getMonth() + 1}`.padStart(2, '0');
        const day = `${date.getDate()}`.padStart(2, '0');
        return `${year}-${month}-${day}`;
    }

    private getDashboardDateRangeBounds(range: string): { fromDate: Date; toDate: Date } {
        const today = new Date();
        today.setHours(0, 0, 0, 0);

        if (range === 'yesterday') {
            const yesterday = new Date(today);
            yesterday.setDate(yesterday.getDate() - 1);
            return {fromDate: yesterday, toDate: yesterday};
        }

        if (range === '7days') {
            const fromDate = new Date(today);
            fromDate.setDate(fromDate.getDate() - 6);
            return {fromDate, toDate: today};
        }

        if (range === 'month') {
            const fromDate = new Date(today);
            fromDate.setDate(fromDate.getDate() - 30);
            return {fromDate, toDate: today};
        }

        return {fromDate: today, toDate: today};
  }

onResults(event: { searchText: string, results: any, totalRecords: number, nextPage: number | null, previousPage: number | null }) {
    this.currentPage = 1;
    this.recordsPerPage = 10;
    this.previousPage = event.previousPage;
    this.nextPage = event.nextPage;
    this.searchText = event.searchText;
    this.todaysActivity = this.formatParkingTimesInActivity(event.results.todays_activity);
    this.totalRecords = event.totalRecords;
}
  
  selectVehilceStatus(){
    this.currentPage = 1;
    this.stats(this.currentPage, this.recordsPerPage)
  }
  

  exportToExcel() {
        this.rawData = {
          'camera_esn': this.activeCameraEsn,
          'status_filter': '',
          'time_range': this.activityDateRange,
          'export_to_excel': true,
          'search_text': this.searchText || ''
        }
        if (this.vehicleStatus){
          this.rawData['status_filter'] = this.vehicleStatus
        }
        if (this.sortColumn) {
          if (this.sortDirection === "desc") {
            this.rawData['sort_column'] = `-${this.sortColumn}`
          }
          else {
            this.rawData['sort_column'] = `${this.sortColumn}`
          }
        }
        this.apiService.exportTodayActivity(this.rawData).pipe(takeUntil(this.destroy$)).subscribe({
             next: (response:any) => {
               const fileName = getFileNameFromResponse(response);
                 if (response.body) {
                     saveAs(response.body, fileName);
                 }
             },
             error: (err) =>{
               this.toastr.error(`${err}`)
             }
           });
         }

  refresh(){
    window.location.reload();
  }

  ngOnDestroy() {
    this.destroy$.next();
    this.destroy$.complete();
    this.isLoading = false;
  }
}
